import React, { useState, useEffect, createContext, useContext } from 'react';
import Toast from './Toast';

// Créer un contexte pour le gestionnaire de toast
const ToastContext = createContext();

// Hook personnalisé pour utiliser le toast
export const useToast = () => useContext(ToastContext);

// Composant gestionnaire de toast
export const ToastManager = ({ children }) => {
  const [toast, setToast] = useState(null);

  // Fonction pour afficher un toast
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    
    // Fermer automatiquement le toast après 3 secondes
    setTimeout(() => {
      setToast(null);
    }, 3000);
  };

  // Exposer la fonction showToast globalement
  useEffect(() => {
    window.showToast = showToast;
    
    return () => {
      delete window.showToast;
    };
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && (
        <Toast 
          message={toast.message} 
          type={toast.type} 
          onClose={() => setToast(null)} 
        />
      )}
    </ToastContext.Provider>
  );
};

export default ToastManager;